// test233
(233 && 0);
